import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import { $image_url, User } from 'js/utils';
import { TRIGGER } from 'js/header/FocusedNav/AccountMenu';
import _Header from "AccountMenu-Header.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenu.tsx?styleId=Header";
import _MenuProfilePic from "AccountMenu-MenuProfilePic.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenu.tsx?styleId=MenuProfilePic";
import _MenuName from "AccountMenu-MenuName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenu.tsx?styleId=MenuName";
import _MenuList from "AccountMenu-MenuList.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenu.tsx?styleId=MenuList";
import _AnchorItem from "AccountMenu-AnchorItem.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/AccountMenu.tsx?styleId=AnchorItem";


const Header = /*#__PURE__*/styled("a", null, {
  displayName: "Header",
  styles: _Header
});

const MenuProfilePic = /*#__PURE__*/styled("img", null, {
  displayName: "MenuProfilePic",
  styles: _MenuProfilePic
});

const MenuName = /*#__PURE__*/styled("span", null, {
  displayName: "MenuName",
  styles: _MenuName
});

const MenuList = /*#__PURE__*/styled("ul", null, {
  displayName: "MenuList",
  styles: _MenuList
});

const AnchorItem = /*#__PURE__*/styled("a", null, {
  displayName: "AnchorItem",
  styles: _AnchorItem
});

const AccountMenu = () => {
  return (
    <>
      <Header href={User.current?.url}>
        {User.current != null && (
          <MenuProfilePic src={$image_url(User.current.photo)} />
        )}
        <MenuName>{User.current?.display_name}</MenuName>
      </Header>

      <MenuList>
        <li>
          <AnchorItem
            href={routes.settings_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Account Settings
          </AnchorItem>
        </li>
        <li>
          <AnchorItem
            href={routes.logout_url({
              from_navbar: true,
              trigger: TRIGGER,
            })}
          >
            Log Out
          </AnchorItem>
        </li>
      </MenuList>
    </>
  );
};

export default AccountMenu;
